import {Injectable} from "@angular/core";

@Injectable({
    providedIn: 'root'
})

export class UserEmailService {
    private email: string;

    constructor() {}


    getEmail(): string {
        return this.email;
    }


    setEmail(email: string) {
        this.email = email;
        localStorage.setItem('userEmail', email); // Guarda en sessionStorage
        console.log('email:', this.email);
    }
}